import { useMemo } from 'react';

import { ProgressMeasurement } from 'components/common/GlobalFiltersInPage/components/progressMeasurementFilter/progressMeasurementFilter';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';

const FILTER_LIST: ProgressMeasurement[] = [
    'activityCompleted',
    'activityCompletedCriticality',
    'activitySubmittedCompletion',
    'activitySubmittedCompletionCriticality',
];

export const useProgressSummaryLogic = ({ ui, api, setIsPayloadReady, widgetViewMode }) => {
    const isPayloadReady = () => {
        const currentPayload = api.getBaselineVsActual.payload;
        if (!currentPayload) return;
        if (
            currentPayload.baselineMetaDataId === undefined ||
            currentPayload.actualMetaDataId === undefined ||
            currentPayload.contractId === undefined ||
            currentPayload.contractId === null ||
            currentPayload.projectId === undefined ||
            currentPayload.projectId === null
        ) {
            return;
        }
        setIsPayloadReady && setIsPayloadReady(true);
    };

    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });
    const milestoneFragnetTaskVersionHashCode = useMemo(() => {
        if (ui.state.milestoneFragnet) {
            return ui.state.milestoneFragnet;
        }

        if (api.getMilestoneFragnet?.data && api.getMilestoneFragnet.data.length > 0) {
            return api.getMilestoneFragnet.data[0].task_version_hash_code;
        }
    }, [api.getMilestoneFragnet?.data, ui.state.milestoneFragnet]);

    const notApplicable =
        FILTER_LIST.includes(ui.state.progressMeasurement) &&
        Boolean(ui.state.resourceType?.length > 0 || ui.state.resource);

    const noResults =
        !Boolean(api.getBaselineVsActual.instance.data?.actual.finishDate) &&
        !Boolean(api.getBaselineVsActual.instance.data?.actual.startDate) &&
        !Boolean(api.getBaselineVsActual.instance.data?.baseLine.finishDate) &&
        !Boolean(api.getBaselineVsActual.instance.data?.baseLine.startDate);

    const isNoData = noResults || notApplicable;

    return { logic: { milestoneFragnetTaskVersionHashCode, isNoData, notApplicable } };
};
